import { useContext } from "react"
import { BuilderContext } from "../BuilderContext"

export function useWorkflowBuilder() {
  const context = useContext(BuilderContext)

  if (!context) throw new Error("useWorkflowBuilder must be used within a BuilderProvider")

  return context
}
